export const LABELS = {
  add: "add",
  edit: "edit",
  editc: "editc",
  delete: "delete",
  error: "error",
  dashboard: "dashboard",
  usermng: "usermng",
  taskmng: "taskmng",
  errormng: "errormng",
  rolmng: "rolmng",
  logout: "logout",
  predsnrv: "PREDICT SNR V",
  predsnrh: "PREDICT SNR H",
};

export const STATUS = {
  ok: "OK",
  alert: "ALERT",
  alarm: "ALARM",
  down: "DOWN",
};

export const STRING_GENERAL = {
  client: "client",
  distri: "distribution",
  access: "access",
  predictall: "getPredTabData",
  predictreal: "getRealDataByIP",
  predictpred: "getPredDataByIP",
  time: "yyyy-MM-dd HH:mm:00",
  timeRAOS: "yyyy-MM-dd",
  SERVER: "SERVER",
  predict: "predict",
  predictsnr: "predictsnr",
  instamesh: "instamesh",
  quality_lap: "quality_lap",
  Status: "Status",
  temperature: "temperature",
  Voltage: "Voltage",
  Cost: "Cost",
  rssi: "rssi",
  rsrp: "rsrp",
  rsrq: "rsrq",
  PMPAP1: "PMP-AP-01",
  PMPAP5: "PMP-AP-05",
};

export const TYPES = {
  distri: "Distribución",
  acceso: "Acceso",
  client: "Cliente",
  pmpap: "PMP-AP",
  pmpsm: "PMP-SM",
  down: "Caidos",
  all: "Todos",
  camion: "CAMION",
  perforadora: "PERFORADORA",
  pilaagua: "PILA AGUA",
};

export const VISIBLE_PAGES = {
  reset: "reset",
  topology: "topology",
  predicts: "predicts",
  predictsnr: "predictsnr",
  management: "management",
  lte: "lte",
  kpi: "kpi",
  dashboard: "dashboard",
  servers: "servers",
  admincsv: "admincsv",
  latency: "latency",
  quality_lap: "quality_lap",
  quality_snr: "quality_snr",
  snr_vertical: "snr_vertical",
  snr_horizontal: "snr_horizontal",
  temp_inst: "temp_inst",
  wire_inst: "wire_inst",
  operability: "operability",
  dbstatus: "dbstatus",
  wiredpeers: "wiredpeers",
  wirelesspeers: "wirelesspeers",
  report: "report",
  alarmreport: "alarmreport",
  allLatency: "allLatency",
  dbmaintenance: "dbmaintenance",
  YAMLMaintenance: "YAMLMaintenance",
  drive: "drive",
  driverajant: "driverajant",
  driveheatmap: "driveheatmap",
  driveClients: "driveClients",
  lastconection: "lastconection",
  monitoring: "monitoring",
  gestorDash: "gestordashboard",
  allview: "allview",
  config: "config",
  statistics: "statistics",
  bandWidth: "bandWidth",
  test: "test",
  raosmap: "raosMap",
  raosinit: "raosINIT",
  raosstatus: "raosSTATUS",
  raospg: "raosPG",
  raoskpi: "raosKPI",
  raosmng: "raosMNG",
  raosreport: "raosREPORT",
  energy: "energy",
  tepeaca: {
    dashboard: "tepeaca_Dashboard",
    kpi: "tepeaca_KPI",
    administracion: "tepeaca_Administracion",
    playback: "tepeaca_playback"
  }
};

export const NAME_PROJECT = {
  cananea: "SmartLinkCananea",
  demo: "SmartLinkDEMO",
  nacozari: "SmartLinkNacozari",
  collahuasi: "SmartLinkCMDIC",
  hcg: "SmartLinkHCGROUP",
  raos: "SmartLinkRAOS",
  tepeaca: "SmartLinkTepeaca",
  lima: "SmartLinkLima"
};

export const TOKEN = `${process.env.VUE_APP_API_TOKEN}`;
